<template>
    <div class="container">
        <div class="im-head">
            <div class="head-left">
                <img class="im-logo" src="../../assets/im/im.png" title="im" />
                <span class="text">IM即时通讯</span>
            </div>
            <div class="cursor head-right" @click="goLastPage">即刻下载</div>
        </div>
        <swiper class="swiper" ref="mySwiper" :options="swiperOption">
            <swiper-slide>
                <div class="item container-one">
                    <div class="body">
                        <template v-if="swiper_index2 === 0">
                            <div class="title animate__animated animate__fadeInUp">SHALL BUY IM即时通讯工具</div>
                            <div class="title-one animate__animated animate__fadeInUp">助您打造专属店铺</div>
                            <p style="animation-delay: .3s;" class="animate__animated animate__fadeInUp">
                                一站式商家工作台，覆盖全链路商家经营场景，专注服务于销巴商家，满足商家全场景经营诉求</p>
                            <p style="animation-delay: .4s;" class="animate__animated animate__fadeInUp">
                                会员、商家、客服可提供不同的聊天服务，让您在聊天中随时随地切换身份，工作生活两不误</p>
                            <div class="link-list animate__animated animate__fadeInUp">
                                <div class="link-list-item">
                                    <img src="../../assets/im/check.png" />
                                    <span class="link">Windows</span>
                                </div>
                                <div class="link-list-item">
                                    <img src="../../assets/im/check.png" />
                                    <span class="link">BigSur</span>
                                </div>
                                <div class="link-list-item">
                                    <img src="../../assets/im/check.png" />
                                    <span class="link">Monterey</span>
                                </div>
                            </div>
                            <div class="download animate__animated animate__fadeInUp">
                                <a download href="https://others-qiniu.shall-buy.com/%E9%94%80%E5%B7%B4IM-2.0.0.dmg">
                                    <div :class="{ 'ios-pic': true, 'download-btn-down': show_btn, 'download-btn-up': !show_btn }"
                                        @mouseenter="mouseenter(1)" @mouseleave="mouseleave(1)">
                                        <div class="text text1"><img src="../../assets/im/mac1.png" />Mac安装包</div>
                                        <div class="text down-pic down-pic-ios">
                                            <img src="../../assets/im/arrow_dwon.png" alt="">
                                        </div>
                                    </div>
                                </a>
                                <a download href="https://others-qiniu.shall-buy.com/%E9%94%80%E5%B7%B4IM%202.0.0.exe">
                                    <div :class="{ 'ios-pic': true, 'windows-pic': true, 'download-btn-down': show1, 'download-btn-up': !show1 }"
                                        @mouseenter="mouseenter(2)" @mouseleave="mouseleave(2)">
                                        <div class="text text1"><img src="../../assets/im/windows.png" />Windows安装包</div>
                                        <div class="text down-pic"><img src="../../assets/im/arrow_dwon.png" alt=""></div>
                                    </div>
                                </a>
                            </div>
                        </template>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="item container-two">
                    <div v-show="swiper_index2 === 1">
                        <div class="head animate__animated animate__fadeInUp">
                            <div class="title">IM即时通讯工具，让聊天<div class="title-skew">体验更美好</div></div>
                        </div>
                        <div id="body_one" class="body animate__animated animate__fadeInUp">
                            <div class="list">
                                <div class="list-item list-item1">
                                    <div class="kong"></div>
                                    <div class="context context-bottom">活动，任何端口都畅聊无阻</div>
                                    <div class="context">支持pc、app、小程序聊天同步</div>
                                    <div class="decorate-line"></div>
                                    <h3 class="htitle">多种聊天方式，沟通更便捷</h3>
                                    <div class="animate-pic">
                                        <img class="animate-pic-first animate-pic1" src="../../assets/im/animate-1.png" alt="">
                                        <img class="animate-pic-two animate-pic1-1" src="../../assets/im/animate-1-1.png" alt="">
                                        <img class="animate-pic-three animate-pic1-11" src="../../assets/im/animate2-22.png" alt="">
                                    </div>
                                </div>
                                <div class="list-item list-item2">
                                    <div class="kong"></div>
                                    <div class="context context-bottom">引用功能，随时随地呼唤好友</div>
                                    <div class="context">支持群聊天、1v1聊天，群消息@功能</div>
                                    <div class="decorate-line"></div>
                                    <h3 class="htitle">多元化互动玩法</h3>
                                    <div class="animate-pic">
                                        <img class="animate-pic-first animate-pic2" src="../../assets/im/animate-2.png" alt="">
                                        <img class="animate-pic-two animate-pic2-2" src="../../assets/im/animate-2-2.png" alt="">
                                        <img class="animate-pic-three animate-pic1-11" src="../../assets/im/animate1-11.png" alt="">
                                    </div>
                                </div>
                                <div class="list-item list-item3">
                                    <div class="kong"></div>
                                    <div class="context context-bottom">机制，保证会话安全，传输更快速</div>
                                    <div class="context">私密加载聊天技术，快速多重安全验证</div>
                                    <div class="decorate-line"></div>
                                    <h3 class="htitle">多安全举措，让您的聊天更安全</h3>
                                    <div class="animate-pic">
                                        <img class="animate-pic-first animate-pic3" src="../../assets/im/animate-3.png" alt="">
                                        <img class="animate-pic-two animate-pic3-3" src="../../assets/im/animate-3-3.png" alt="">
                                        <img class="animate-pic-three animate-pic1-11" src="../../assets/im/animate3-33.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="item swiper3-box">
                    <swiper class="swiper3" ref="mySwiper3" :options="swiperOption3">
                        <swiper-slide>
                            <div v-show="swiper_idx1 === 0" class="item container-three">
                                <div class="head animate__animated animate__fadeInUp">
                                    <div class="title"><div class="title-skew">多种身份</div>随意切换，工作生活两不误</div>
                                </div>
                                <div id="body_two" class="body">
                                        <div class="body-left animate__animated animate__fadeInUp">
                                            <div class="product-title">会员身份</div>
                                            <div class="product-line"></div>
                                            <div class="product-text">
                                                <div>与您的好友尽情畅聊，发送表情、文件、图片、视</div>
                                                <div>频、语音、引用等多重体验</div>
                                            </div>
                                        </div>
                                        <div class="body-right animate__animated animate__fadeInUp">
                                            <svg width="100%" height="100%" viewBox="0 0 764 772"
                                                    version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <image xlink:href="../../assets/im/chat_bg1.png" x="200" y="0" width="581" height="615" />
                                                    <g>
                                                        <circle r="6" cx="410" cy="200" style="fill: #1560FA; stroke: rgba(21, 96, 250, 0.2); stroke-width: 8"></circle>
                                                        <polyline points="410,206 410,380 150,380"
                                                            style="fill: transparent; stroke: #b6cdfe; stroke-width: 1" />
                                                        <image xlink:href="../../assets/im/tag_yy.svg" x="0" y="343"
                                                            height="79px" width="171px" />
                                                    </g>
                                                    <g>
                                                        <circle r="6" cx="330" cy="295"
                                                            style="fill: #1560FA; stroke: rgba(21, 96, 250, 0.2); stroke-width: 8">
                                                        </circle>
                                                        <polyline points="330,301 330,360 500,360 500,620"
                                                            style="fill: transparent; stroke: #b6cdfe; stroke-width: 1" />
                                                        <image xlink:href="../../assets/im/tag_fsyy.png" x="415" y="615"
                                                            height="79px" width="171px" />
                                                    </g>
                                                    <g>
                                                        <circle r="6" cx="277" cy="520"
                                                            style="fill: #1560FA; stroke: rgba(21, 96, 250, 0.2); stroke-width: 8">
                                                        </circle>
                                                        <polyline points="277,526 277,670"
                                                            style="fill: transparent; stroke: #b6cdfe; stroke-width: 1" />
                                                        <image xlink:href="../../assets/im/tag_fsbq.png" x="190" y="665"
                                                            height="79px" width="171px" />
                                                    </g>
                                                    <g>
                                                        <circle r="6" cx="317" cy="480"
                                                            style="fill: #1560FA; stroke: rgba(21, 96, 250, 0.2); stroke-width: 8">
                                                        </circle>
                                                        <polyline points="317,474 315,315 145,315 145,175"
                                                            style="fill: transparent; stroke: #b6cdfe; stroke-width: 1" />
                                                        <image xlink:href="../../assets/im/tag1.png" x="60" y="125"
                                                            height="79px" width="171px" />
                                                    </g>
                                                    <g>
                                                        <image xlink:href="../../assets/im/tag_picture.png" x="295" y="510"
                                                            height="60px" width="60px" />
                                                            <text x="315" y="578" font-size="10">图片</text>
                                                        <image xlink:href="../../assets/im/tag_video.png" x="365" y="510"
                                                            height="60px" width="60px" />
                                                            <text x="385" y="578" font-size="10">视频</text>
                                                    </g>
                                                </svg>
                                        </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div v-show="swiper_idx1 === 1" class="item container-four">
                                <div id="body_two" class="body">
                                        <div class="body-right animate__animated animate__fadeInUp">
                                            <div>
                                                <img class="big-pic1" src="../../assets/im/chat_bg2.png" alt="" />
                                                <img class="big-pic2" src="../../assets/im/chat_bg22.png" alt="" />
                                            </div>
                                            <div class="svg">
                                                <svg width="100%" height="100%" viewBox="0 0 757 728"
                                                    version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <g>
                                                        <circle r="6" cx="65" cy="250"
                                                            style="fill: #1560FA; stroke: rgba(21, 96, 250, 0.2); stroke-width: 8">
                                                        </circle>
                                                        <polyline points="65,245 65,175 480,175"
                                                            style="fill: transparent; stroke: #b6cdfe; stroke-width: 1" />
                                                        <image xlink:href="../../assets/im/tag_yjcx.png" x="470" y="140"
                                                            height="79px" width="171px" />
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="body-left animate__animated animate__fadeInUp">
                                            <div class="product-title">商户身份</div>
                                            <div class="product-line"></div>
                                            <div class="product-text">
                                                高效解决客户疑问，一键查询客户所购买的商品订单详情
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div v-show="swiper_idx1 === 2" class="item container-five">
                                <div id="body_two" class="body">
                                        <div class="body-left animate__animated animate__fadeInUp">
                                            <div class="product-title">客服身份</div>
                                            <div class="product-line"></div>
                                            <div class="product-text">
                                                高效一键发送高频常用语、常用链接、常用文件，为您排忧解难
                                            </div>
                                        </div>
                                        <div class="body-right animate__animated animate__fadeInUp">
                                            <img class="big-pic" src="../../assets/im/chat_five.png" alt="" />
                                            <div class="svg">
                                                <svg width="100%" height="100%" viewBox="0 0 757 728"
                                                    version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <g>
                                                        <circle r="6" cx="485" cy="215"
                                                            style="fill: #1560FA; stroke: rgba(21, 96, 250, 0.2); stroke-width: 8">
                                                        </circle>
                                                        <polyline points="480,215 230,215 230,285"
                                                            style="fill: transparent; stroke: #b6cdfe; stroke-width: 1" />
                                                        <image xlink:href="../../assets/im/link_file.png" x="140" y="280"
                                                            height="79px" width="188px" />
                                                    </g>
                                                    <g>
                                                        <circle r="6" cx="290" cy="465"
                                                            style="fill: #1560FA; stroke: rgba(21, 96, 250, 0.2); stroke-width: 8">
                                                        </circle>
                                                        <polyline points="290,460 290,400 160,400"
                                                            style="fill: transparent; stroke: #b6cdfe; stroke-width: 1" />
                                                        <image xlink:href="../../assets/im/cyy.png" x="5" y="365" height="79px"
                                                            width="171px" />
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="item container-six example-3d">
                    <div v-show="swiper_index2 === 3">
                        <div class="head animate__animated animate__fadeInUp">
                            <div class="title">
                                <div class="title-skew">一体化</div>的操作体验
                            </div>
                        </div>
                        <div class="container-six-text animate__animated animate__fadeInUp">优化工作台菜单与界面，为商家提供简洁高效的经营体验
                        </div>
                        <div class="swiper2-container-box animate__animated animate__fadeInUp">
                            <swiper class="swiper2" ref="mySwiper2" :options="swiperOption2">
                                <swiper-slide>
                                    <div :class="{'swpier-pic-item': true, focus: swiper_idx === 0}"><img src="../../assets/im/swiper3.png" alt=""></div>
                                </swiper-slide>
                                <swiper-slide>
                                    <div :class="{'swpier-pic-item': true, focus: swiper_idx === 1}"><img src="../../assets/im/swiper2.png" alt=""></div>
                                </swiper-slide>
                                <swiper-slide>
                                    <div :class="{'swpier-pic-item': true, focus: swiper_idx === 2}"><img src="../../assets/im/swiper1.png" alt=""></div>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="progress-container animate__animated animate__fadeInUp">
                            <div class="progress-bar-box">
                                <div class="progress-bar-persent" :style="{ left: swiper_index + '%' }"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="item container-seven">
                    <div v-show="swiper_index2 === 4" class="video-box">
                    <!-- <template v-if="show7"> -->
                        <img class="decorate-pic1" src="../../assets/im/file1.png">
                        <img class="decorate-pic2" src="../../assets/im/file2.png">
                        <div class="head animate__animated animate__fadeInUp">
                            <div class="title">爽快的<div class="title-skew">双向收发</div>体验</div>
                        </div>
                        <div class="container-seven-text animate__animated animate__fadeInUp">
                            通过IM，电脑和手机上的文件都能收发自如，轻松你的工作和生活</div>
                        <div class="container-seven-video animate__animated animate__fadeInUp">
                            <div class="video-container">
                                <video ref="videoRef" @ended="onended" @click="videoClick" src="../../assets/im/im.mp4"></video>
                                <div v-show="pause" class="video-bf" @click="videoClick">
                                    <img src="../../assets/im/logo2.png" alt="">
                                    <div class="video-text">
                                        <div class="video-text1">操作指南</div>
                                        <div class="video-text-line"></div>
                                        <div class="video-text1">带您了解即时通讯</div>
                                    </div>
                                    <div class="video-text-en">instructions Introduce you to instant messaging</div>
                                </div>
                                <img v-show="pause" src="../../assets/im/video_decorat.png" class="im-video-decorate" />
                                <img class="video-bottom-bg" src="../../assets/im/video_bttom_bg.png" alt="">
                            </div>
                            <div class="qipao">
                                <div class="qipao-item qipao-item1">沟通，是通向友谊的桥梁</div>
                                <div class="qipao-item qipao-item3">沟通，是联络感情的纽带</div>
                                <div class="qipao-item qipao-item4">沟通，是联络感情的纽带</div>
                                <div class="qipao-item qipao-item5">沟通，是通向友谊的桥梁</div>
                                <div class="qipao-item qipao-item6">沟通，是事业成功的基础</div>
                                <div class="qipao-item qipao-item9"><img src="../../assets/im/voice.svg" alt=""><span>15s</span></div>
                                <div class="qipao-item qipao-item10"><img src="../../assets/im/voice.svg" alt=""><span>15s</span></div>
                                <div class="qipao-item qipao-item7"><img src="../../assets/im/voice.svg" alt=""><span>15s</span></div>
                                <div class="qipao-item qipao-item8"><img src="../../assets/im/voice.svg" alt=""><span>15s</span></div>
                                <div class="qipao-item qipao-item11"><img src="../../assets/im/voice.svg" alt=""><span>15s</span></div>
                                <div class="qipao-item qipao-item2">沟通是人类恒古不变的梦想，IM为您架起桥备份</div>
                            </div>
                        </div>
                    <!-- </template> -->
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide class="swiper-no-swiping">
                <div v-if="swiper_index2 === 5" class="item container-eight">
                    <div class="container-eight-body">
                        <div class="head animate__animated animate__fadeInUp">
                            <div class="title">
                                <div class="title-skew">下载</div>IM即时通讯
                            </div>
                        </div>
                        <div class="container-eight-text animate__animated animate__fadeInUp">无论您身在何处，无论他们身在何处-IM让天涯变咫尺</div>
                        <div class="download-pic-box animate__animated animate__fadeInUp">
                                <a download href="https://others-qiniu.shall-buy.com/%E9%94%80%E5%B7%B4IM-2.0.0.dmg">
                                    <div :class="{ 'ios-pic': true, 'download-btn-down': show_btn, 'download-btn-up': !show_btn }"
                                        @mouseenter="mouseenter(1)" @mouseleave="mouseleave(1)">
                                        <div class="text text1"><img class="download-mac-pic" src="../../assets/im/mac_black.png" />Mac版本下载</div>
                                        <div class="text down-pic down-pic-ios">
                                            <img src="../../assets/im/down_black.png" alt="">
                                        </div>
                                    </div>
                                </a>
                                <a download href="https://others-qiniu.shall-buy.com/%E9%94%80%E5%B7%B4IM%202.0.0.exe">
                                    <div :class="{ 'ios-pic': true, 'windows-pic': true, 'download-btn-down': show1, 'download-btn-up': !show1 }"
                                        @mouseenter="mouseenter(2)" @mouseleave="mouseleave(2)">
                                        <div class="text text1"><img class="download-windows-pic" src="../../assets/im/windows_2.png" />Windows版本下载</div>
                                        <div class="text down-pic">
                                            <img src="../../assets/im/arrow_dwon.png" alt="">
                                        </div>
                                    </div>
                                </a>
                        </div>
                    </div>
                    <div class="container-eight-footer animate__animated animate__fadeInUp">
                        <div class="footer-left">
                            <div class="footer-link-list">
                                <a class="footer-link-item" @click="goUrl('/amap')">联系方式</a>
                                <div class="footer-link-line"></div>
                                <a class="footer-link-item" @click="goUrl('/talnet')">人才招聘</a>
                                <div class="footer-link-line"></div>
                                <a class="footer-link-item" @click="goUrl('/about')">关于我们</a>
                            </div>
                            <div class="footer-company">
                                <div class="footer-company-item"><span>座机：40000-571-671</span><span class="company-item-mx">电话：0571-87561709</span><span>邮箱：admin@shall-buy.com</span></div>
                                <div class="footer-company-item"><span>地址：解放东路33号财富金融中心西楼3F</span></div>
                                <div class="footer-company-item">@1999-2020 浙江销巴科技有限公司 浙ICP备16036486号-1</div>
                            </div>
                        </div>
                        <div class="footer-right">
                            <div class="code-box">
                                <img src="../../assets/im/er_code.png" alt="">
                                <div class="code-text">关注销巴生活微信公众号</div>
                            </div>
                            <div class="code-box">
                                <img src="../../assets/im/er_code.png" alt="">
                                <div class="code-text">下载销巴生活APP</div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
let deviceWidth = document.documentElement.clientWidth;
let videoEle = null;
const page_name = "impc";
let timer = null;
let timer2 = null;
export default {
    name: "IMPC",
    data() {
        return {
            routered: false,
            show_btn: true,
            show1: true,
            pause: true,
            swiper_index: 0,
            swiper_idx1: -1,
            swiper_index2: 0,
            swiper_idx: 0,
            swiperOption: {
                direction: 'vertical',
                speed: 500,
                 preventInteractionOnTransition : true,
                mousewheel: true,
                mousewheel: {
                    thresholdDelta: 30,
                    thresholdTime:2000,
                },
                on: {
                    //监听滑动切换事件，返回swiper对象
                    slideChange: () => {
                        let swiper = this.$refs.mySwiper.$swiper;
                        let swiper3 = this.$refs.mySwiper3.$swiper;
                        let swiper2 = this.$refs.mySwiper2.$swiper;
                        if (swiper) {
                            // if(!timer){
                            //    swiper.disable();
                            //    timer = setTimeout(() =>{
                            //        swiper.enable();
                            //        timer = null;
                            //    },1500)
                            // }
                            setTimeout(() => {
                                this.swiper_index2 = swiper.activeIndex;
                            }, 300);
                            if (swiper.activeIndex === 2) {
                                // if(!timer2){
                                //     swiper3.disable();
                                //     timer2 = setTimeout(() =>{
                                //         swiper3.enable();
                                //         timer2 = null;
                                //     },1500)
                                // }
                                if (swiper3 && swiper3.activeIndex === 0) {
                                    setTimeout(() => {
                                        this.swiper_idx1 = 0;
                                    }, 300);
                                }
                                if (swiper3 && swiper3.activeIndex === 2) {
                                    setTimeout(() => {
                                        this.swiper_idx1 = 2;
                                    }, 300);
                                }
                            } else {
                                this.swiper_idx1 = -1;
                            }
                            if (swiper2 && swiper.activeIndex === 3) {
                                swiper2.slideTo(0, 100, true);
                            }
                            if (swiper.activeIndex === 4) {
                                setTimeout(() => {
                                    this.pause = false;
                                    this.$refs.videoRef.play();
                                },1000);
                            } else {
                                if (!this.pause) {
                                    this.pause = true;
                                    this.$refs.videoRef.pause();
                                    this.$refs.videoRef.currentTime = 0;
                                }
                            }
                        }
                    },
                    slideChangeTransitionStart:()=>{
                        this.$refs.mySwiper3.$swiper.mousewheel.disable(); 
                        this.$refs.mySwiper.$swiper.mousewheel.disable(); 
                    },
                    slideChangeTransitionEnd:()=>{
                        setTimeout(()=>{
                            this.$refs.mySwiper3.$swiper.mousewheel.enable(); 
                            this.$refs.mySwiper.$swiper.mousewheel.enable(); 
                        },1000)
                    }
                }
            },
            swiperOption2: {
                initialSlide: 0,
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                on: {
                    //监听滑动切换事件，返回swiper对象
                    slideChange: () => {
                        let swiper = this.$refs.mySwiper2.$swiper;
                        if (swiper) {
                            this.swiper_index = 33 * swiper.activeIndex;
                            this.swiper_idx = swiper.activeIndex;
                        }
                    }
                }
            },
            swiperOption3: {
                direction: 'vertical',
                speed: 500,
                preventInteractionOnTransition : true,
                mousewheel: true,
                mousewheel: {
                    // releaseOnEdges: true,
                    thresholdDelta: 30,
                    thresholdTime: 1500,
                },
                nested:true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    //监听滑动切换事件，返回swiper对象
                    slideChange: () => {
                        let swiper3 = this.$refs.mySwiper3.$swiper;
                        let swiper = this.$refs.mySwiper.$swiper;
                        if(swiper && !timer){
                        //    swiper.disable();
                        //    timer = setTimeout(() =>{
                        //        swiper.enable();
                        //        timer = null;
                        //    },1500)
                        }
                        if (swiper3) {
                            // if(!timer2){
                            //     swiper3.disable();
                            //     timer2 = setTimeout(() =>{
                            //         swiper3.enable();
                            //         timer2 = null;
                            //     },1500)
                            // }
                            setTimeout(() => {
                                this.swiper_idx1 = swiper3.activeIndex;
                            }, 300);
                        }
                    },
                    slideChangeTransitionStart:()=>{
                        this.$refs.mySwiper3.$swiper.mousewheel.disable(); 
                        this.$refs.mySwiper.$swiper.mousewheel.disable(); 
                    },
                    slideChangeTransitionEnd:()=>{
                        setTimeout(()=>{
                            this.$refs.mySwiper3.$swiper.mousewheel.enable(); 
                            this.$refs.mySwiper.$swiper.mousewheel.enable(); 
                        },1000)
                    }
                }
            }
        };
    },
    created() {
        this.mobile = navigator.userAgent.includes("Mobile");
    },
    methods: {
        goUrl(url){
            window.open(`${url}`, "_blank");
            // this.$router.push(url);
        },
        setHtmlFontSize() {
            if (document.documentElement.clientWidth < 960 && page_name === "impc" && !this.routered) {
                this.routered = true;
                this.$router.push("/im/mobile");
            }
            deviceWidth =
                document.documentElement.clientWidth < 960
                    ? 960
                    : document.documentElement.clientWidth;
            document.getElementsByTagName("html")[0].style.cssText =
                "font-size:" + deviceWidth / 19.2 + "px !important";
        },
        videoClick(){
            if(this.pause){
                this.pause = false;
                this.$refs.videoRef.play();
            }else{
                this.pause = true;
                this.$refs.videoRef.pause();
            }
        },
        onended(){
            this.pause = true;
        },
        mouseenter(i) {
            if (i === 1) {
                this.show_btn = false;
            } else if (i === 2) {
                this.show1 = false;
            }
        },
        mouseleave(i) {
            if (i === 1) {
                this.show_btn = true;
            } else if (i === 2) {
                this.show1 = true;
            }
        },
        videoPlayFn(){
            if (this.pause) {
                this.pause = false;
            }
        },
        goLastPage(){
            const swiperRef = this.$refs.mySwiper.$swiper;
            if (swiperRef.activeIndex !== 5) {
                swiperRef.slideTo(5, 1000, false);
            }
        },
        onmouseover(){
            this.$refs.mySwiper2.$swiper.autoplay.stop();
        }, 
        onmouseout(){
            this.$refs.mySwiper2.$swiper.autoplay.start();
        },
        changeFavicon() {
            let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            if (link) {
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = "/im.ico";
                document.getElementsByTagName('head')[0].appendChild(link);
            }
        }
        // videoPauseFn(){
        //     // console.log("bbbbb");
        //     // if (!this.pause) {
        //     //     this.pause = true;
        //     // }
        // }
    },
    mounted() {
        this.routered = false;
        this.changeFavicon();
        videoEle = this.$refs.videoRef;
        // document.getElementsByClassName("bg-color")[0].style.display = "none";
        // document.getElementsByClassName("footer")[0].style.display = "none";
        // const other = document.getElementById("cert_show_img");
        // other && (other.parentElement.parentElement.style.display = "none");
        this.setHtmlFontSize();
        window.addEventListener("resize", this.setHtmlFontSize, false);
        videoEle.addEventListener('play', this.videoPlayFn);
        // videoEle.addEventListener('pause', this.videoPauseFn);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setHtmlFontSize);
        videoEle.removeEventListener("play", this.videoPlayFn);
        // videoEle.removeEventListener("pause", this.videoPauseFn);
    },
    // beforeRouteEnter (to, from, next) {
    //     // document.getElementsByClassName("bg-color")[0].style.display = "none";
    //     next();
    // }
};
</script>
<style>
#app {
    background-color: #ffffff;
}
</style>
<style lang="less" scoped>
.tovh(@name,@px) {
    @{name}: round(@px / 1080, 2) * 100vh;
}
.tovw(@name,@px) {
    @{name}: round(@px / 1920, 2) * 100vw;
}
.container {
    min-width: 960px;
    height: 100vh;
    overflow: hidden;
    transform: scale(1);
    user-select: none;
}
video::-webkit-media-controls-download-button {
    display:none;
}
video::-webkit-media-controls-fullscreen-button {    
    display: none;
}
video::-webkit-media-controls-enclosure {
    overflow: hidden;
}
@keyframes normalDown {
    0% {
        transform: translate3d(0, -100%, 0)
    }

    40% {
        transform: translate3d(0, 10%, 0)
    }

    70% {
        transform: translate3d(0, -10%, 0)
    }

    85% {
        transform: translate3d(0, 3%, 0)
    }

    to {
        transform: translateZ(0)
    }
}

@keyframes activeUp {
    0% {
        transform: translateZ(0)
    }
    
    40% {
        transform: translate3d(0, -110%, 0)
    }
    
    70% {
        transform: translate3d(0, -90%, 0)
    }
    
    85% {
        transform: translate3d(0, -110%, 0)
    }
    
    to {
        transform: translate3d(0, -100%, 0)
    }
}

@keyframes activeDown {
    0% {
        transform: translate3d(0, -100%, 0)
    }
    to {
        transform: translateZ(0)
    }
}

@keyframes normalUp {
    0% {
        transform: translateZ(0)
    }

    to {
        transform: translate3d(0, -100%, 0)
    }
}
.cursor {
    cursor: pointer;
}
.im-head {
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    // height: 80px;
    .tovh(height, 80);
    min-height: 40px;
    padding: 0 19%;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.08);    
    z-index: 999;
    .im-logo {
        width: 25px;
        height: 25px;
    }
    .head-left {
        display: flex;
        align-items: center;
    }
    .text {
        margin-left: 8px;
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #1660fa;
        line-height: 21px;
    }
    .head-right {
        width: 110px;
        height: 40px;
        background: linear-gradient(111deg, #4A86FF 0%, #1763FF 100%);
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        transition: all .3s;
        &:hover{
            box-shadow: 0px 4px 10px 1px rgba(29, 102, 255, 0.4);
        }
    }
}

.item {
    width: 100%;
    height: 100vh;
    .head .title{
        display: flex;
    }
    .title-skew {
        position: relative;
        &::after {
            position: absolute;
            content: "";
            bottom: 0;
            left: 0;
            width: 100%;
            height: 0.07rem;
            transform: skewX(-45deg);
            background-color: #b2ccff;
        }
    }
}
.swiper-container {
    width: 100%;
    height: 100%;

    /deep/ .swiper-pagination {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    /deep/ .swiper-pagination .swiper-pagination-bullet {
        margin: 3px 0;
        width: 16px;
        height: 4px;
        background: rgba(21, 96, 250, 0.5);
        border-radius: 8px 8px 8px 8px;
        transition: all .5s;
    }

    /deep/ .swiper-pagination .swiper-pagination-bullet-active {
        width: 28px;
        height: 4px;
        background: #1560FA;
        border-radius: 8px 8px 8px 8px;
        transition: all .5s;
    }
}

.example-3d {
    width: 100%;
    .progress-container {
        display: flex;
        justify-content: center;
        .tovh(margin-top, 58);

        .progress-bar-box {
            position: relative;
            width: 1.8rem;
            height: 1px;
            background-color: #D5D5D5;
        }

        .progress-bar-persent {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0.6rem;
            height: 6px;
            background-color: #1560FA;
            transition: left .5s;
        }
    }

    .swiper2-container-box {
        .tovh(margin-top, 120);
        height: 100%;
        width: 100vw;
        overflow: visible;
    }

    .swiper2 {
        // .tovh(height, 574);
        // height: 52vw;
        width: 100%;
        overflow: visible;

        .swiper-slide {
            .tovw(width, 918);
            // width: 52vw;
            margin: 0 0.78rem;
            // .tovh(height, 574);
            // height: 52vw;

            .swpier-pic-item {
                // .tovh(height, 574);
                // height: 52vw;
                box-shadow: 0 8px 22px 1px rgba(21, 96, 250, .08);
                border-radius: 10px;
                opacity: 0.5;
                overflow: hidden;
                transition: opacity .5s;
                img{
                    // height: 52vw;
                    width: 100%;
                    display: block;
                }
            }
            .focus{
                opacity: 1;
            }
        }
    }
}

svg path,
svg polyline {
    fill: transparent;
    stroke: #b6cdfe;
    stroke-linejoin: miter;
}

svg g path,
svg polyline {
    stroke-dasharray: 3;
    stroke-dashoffset: 1000;
    stroke-width: 1;
    -webkit-transition: stroke-dashoffset 2s;
    transition: stroke-dashoffset 2s;
    animation: strok 2s;
    animation-fill-mode: forwards;
}

@keyframes strok {
    100% {
        stroke-dashoffset: 0;
    }
}

.container-one {
    display: flex;
    flex-direction: column;

    .title {
        font-size: 0.48rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        .tovh(line-height, 56);
        // line-height: 56px;
        letter-spacing: 4px;
        text-align: center;
    }

    .body {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        background: url("../../assets/im/box_bg11.png");
        background-position: top left;
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .title-one {
            .tovh(margin-top, 56);
            .tovh(margin-bottom, 32);
            // margin-top: 0.54rem;
            font-size: 0.36rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            .tovh(line-height, 42);
            // line-height: 42px;
            text-align: center;
            animation-delay: .2s;
        }

        p {
            // .tovh(margin-top, 24);
            // margin-top: 24px;
            font-size: 0.2rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            .tovh(line-height, 23);
            // line-height: 23px;
            text-align: center;
            &:nth-of-type(2){
                .tovh(margin-top, 24);
            }
        }

        .link-list {
            display: flex;
            // margin-top: 48px;
            .tovh(margin-top, 48);
            animation-delay: .6s;

            .link-list-item {
                display: flex;
                align-items: center;

                // margin-right: 52px;
                &:nth-of-type(2) {
                    margin: 0 0.32rem;
                }
            }

            img {
                width: 0.17rem;
                height: 0.17rem;
                margin-right: 4px;
            }

            span {
                font-size: 0.2rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #6798ff;
                line-height: 23px;
            }
        }

        .download {
            display: flex;
            // margin-top: 1.71rem;
            .tovh(margin-top, 171);
            font-size: 0.2rem;
            font-family: PingFang SC-Medium, PingFang SC;
            animation-delay: .7s;

            .text {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
            }

            .text1 {
                img {
                    margin-right: 12px;
                    width: 0.18rem;
                    height: 0.24rem;
                }
            }
            
            .down-pic {
                img {
                    width: 0.36rem;
                    height: 0.36rem;
                }
            }
            .down-pic-ios{
                font-size: 0.2rem;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                img {
                    margin-left: 0.12rem;
                    // width: 0.22rem;
                    // height: 0.2rem;
                }
            }
            .ios-pic {
                margin: 0 30px 0 0;
                width: 2.49rem;
                height: 0.6rem;
                background-color: #000000;
                box-shadow: 0px 4px 10px 1px rgba(47, 47, 47, 0.4);
                border-radius: 34px;
                opacity: 1;
                filter: blur(undefinedpx);
                color: #ffffff;
                cursor: pointer;
                overflow: hidden;
            }

            .windows-pic {
                margin: 0 0 0 30px;
                background: #1660FA;
                box-shadow: 0px 4px 10px 1px rgba(29, 102, 255, 0.4);
            }

            .download-btn-down {
                .down-pic {
                    -webkit-animation-play-state: paused;
                    animation-play-state: paused;
                    -webkit-animation: activeDown .2s forwards;
                    animation: activeDown .2s forwards;
                }

                .text1 {
                    -webkit-animation-play-state: paused;
                    animation-play-state: paused;
                    -webkit-animation: normalDown .5s forwards;
                    animation: normalDown .5s forwards;
                }
            }

            .download-btn-up {
                .down-pic {
                    -webkit-animation-play-state: paused;
                    animation-play-state: paused;
                    -webkit-animation: activeUp .5s forwards;
                    animation: activeUp .5s forwards;
                }

                .text1 {
                    -webkit-animation-play-state: paused;
                    animation-play-state: paused;
                    -webkit-animation: normalUp .2s forwards;
                    animation: normalUp .2s forwards;
                }
            }
        }
    }
}

.container-two {
    .tovh(padding-top, 90);
    // padding-top: 0.9rem;
    background: url("../../assets/im/box_bg2.png");
    background-position: top left;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .head {
        display: flex;
        justify-content: center;
    }

    .title {
        position: relative;
        font-size: 0.44rem;
        font-family: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #050029;
        line-height: 0.72rem;
        text-align: center;
    }

    @keyframes animatepic {
        from {
            background-position-y: 0px;
        }

        to {
            background-position-y: -1276px;
        }
    }

    @keyframes animatedebunce {
        0% {
            transform: scale(1) rotate(0);
        }
        30% {
            transform: scale(1.7) rotate(15deg) translateX(15px) translateY(-20px);
        }
        60% {
            transform: scale(1.5) rotate(15deg) translateX(10px) translateY(-20px);
        }
        100% {
            transform: scale(1.6) rotate(15deg) translateX(10px) translateY(-20px);
        }
    }

    @keyframes animatedebunce2 {
        0% {
            transform: scale(1) rotate(0);
        }
        30% {
            transform: scale(1.7) rotate(-15deg) translateX(-15px) translateY(-20px);
        }
        60% {
            transform: scale(1.5) rotate(-15deg) translateX(-10px) translateY(-20px);
        }

        100% {
            transform: scale(1.6) rotate(-15deg) translateX(-10px) translateY(-20px);
        }
    }
    @keyframes animatedebunce3 {
        0% {
            transform: scaleY(1);
        }

        100% {
            transform: scaleY(1.6);
        }
    }
    .list {
        display: flex;
        .tovh(margin-top, 200);
        .list-item1 {
            background: url("../../assets/im/list_pic3.png");
        }

        .list-item2 {
            margin: 0 31px;
            background: url("../../assets/im/list_pic2.png");
        }

        .list-item3 {
            background: url("../../assets/im/list_pic1.png");
        }
        .list-item {
            position: relative;
            display: flex;
            flex-direction: column-reverse;
            align-items: center;
            // margin-top: 18vh;
            // margin-top: 2rem;
            // padding-bottom: 0.91rem;
            // width: 19.5vw;
            // height: 40vh;
            width: 3.75rem;
            height: 4.32rem;
            box-shadow: 8px 8px 40px 1px rgba(22, 96, 250, 0.08);
            border-radius: 0.32rem;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            transition: all .5s;
            .animate-pic-three{
                position: absolute;
                bottom: 1.77rem;
                left: 0.95rem;
                width: 1.84rem;
                height: 0.5rem;
            }
            &:hover {
                .context {
                    margin-bottom: 0;
                    opacity: 1;
                }

                .animate-pic {
                    transform: translateY(-1.2rem);

                    .animate-pic-first {
                        animation: animatedebunce2 1.5s forwards;
                    }

                    .animate-pic-two {
                        animation: animatedebunce 1.5s forwards;
                    }
                    .animate-pic-three{
                        animation: animatedebunce3 1.5s forwards;
                    }
                }
            }
        }
        // @media screen and (max-width: 1024px) {
        //     --hover_h: -5vh;
        // }
        .htitle {
            font-size: 0.22rem;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 0.27rem;
        }

        .decorate-line {
            margin-top: 0.1rem;
            margin-bottom: 0.12rem;
            width: 0.84rem;
            height: 3px;
            background: #ECF2FF;
            border-radius: 99px;
        }

        .context {
            // height: 0;
            // margin-top: 0.12rem;
            // margin-bottom: -0.91rem;
            opacity: 0;
            font-size: 0.18rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 0.36rem;
            text-align: center;
            transition: all .5s;
        }
        .context-bottom{
            margin-bottom: -0.91rem;
        }
        .kong {
            width: 100%;
            height: 0.91rem;
        }

        .animate-pic {
            flex: 1;
            position: relative;
            margin-bottom: 0.32rem;
            width: 100%;
            // width: 1.82rem;
            // height: 1.7rem;
            transition: all .5s;

            .animate-pic1 {
                position: absolute;
                top: 0.96rem;
                left: 1.27rem;
                // top: 0.2rem;
                // left: 0.21rem;
                width: 0.96rem;
                height: 0.96rem;
                z-index: 2;
                transition: all .3s;
            }

            .animate-pic1-1 {
                position: absolute;
                top: 1.2rem;
                left: 1.52rem;
                // top: 0.4rem;
                // left: 0.6rem;
                width: 0.96rem;
                height: 0.96rem;
                z-index: 1;
                transition: all .3s;
            }
            .animate-pic1-11 {
                position: absolute;
                top: 2.05rem;
                left: 0.95rem;
                width: 1.84rem;
                height: 0.5rem;
                z-index: 1;
                transition: all .3s;
            }
            .animate-pic2 {
                position: absolute;
                // top: 0.12rem;
                // left: 0.31rem;
                top: 0.96rem;
                left: 1.27rem;
                width: 0.96rem;
                height: 0.96rem;
                z-index: 2;
                transition: all .3s;
            }

            .animate-pic2-2 {
                position: absolute;
                // top: 0.4rem;
                // left: 0.51rem;
                top: 1.2rem;
                left: 1.52rem;
                width: 0.96rem;
                height: 0.96rem;
                z-index: 1;
                transition: all .3s;
            }
            .animate-pic3 {
                position: absolute;
                // top: 0.16rem;
                // left: 0.39rem;
                top: 0.96rem;
                left: 1.27rem;
                width: 0.96rem;
                height: 0.96rem;
                z-index: 2;
                transition: all .3s;
            }

            .animate-pic3-3 {
                position: absolute;
                // top: 0.4rem;
                // left: 0.51rem;
                top: 1.2rem;
                left: 1.52rem;
                width: 0.96rem;
                height: 0.96rem;
                z-index: 1;
                transition: all .3s;
            }
        }
        
    }

    .body {
        display: flex;
        justify-content: center;
        // margin-top: 1.2rem;

        .body-left {
            max-width: 4.75rem;
            margin-right: 1rem;

            .product-title {
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #1560fa;
                line-height: 36px;
            }

            .product-line {
                margin: 16px 0 24px 0;
                width: 34px;
                height: 7px;
                background: #1560fa;
                border-radius: 99px;
            }

            .product-text {
                margin-top: 12px;
                font-size: 0.2rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 36px;
            }
        }

        .body-right {
            position: relative;
            // width: 27%;
            // height: 51%;
            width: 5.52rem;
            height: 5.57rem;
            .svg {
                position: absolute;
                top: 0;
                right: 0;
                width: 7.57rem;
                height: 7.28rem;
                // width: 757px;
                // height: 728px;
            }
        }

        .big-pic {
            width: 100%;
            height: 100%;
        }
    }
}
.swiper3-box{
    .swiper-container{
        background: url("../../assets/im/swiper3_bg.png");
        background-position: top left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
}
.container-three {
    .tovh(padding-top, 88);
    
    .head {
        display: flex;
        justify-content: center;
    }

    .title {
        position: relative;
        font-size: 0.44rem;
        font-family: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #050029;
        line-height: 0.72rem;
        text-align: center;
    }

    .body {
        flex: 1;
        display: flex;
        justify-content: center;
        // margin-top: 1.2rem;
        .tovh(margin-top, 113);

        .body-left {
            padding-top: 1.44rem;
            // width: 4.75rem;
            margin-right: 1rem;

            .product-title {
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #1560fa;
                line-height: 36px;
            }

            .product-line {
                margin: 16px 0 24px 0;
                width: 34px;
                height: 7px;
                background: #1560fa;
                border-radius: 99px;
            }

            .product-text {
                font-size: 0.2rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 36px;
            }
        }

        .body-right {
            position: relative;
            // width: 5.81rem;
            // height: 6.15rem;
            width: 7.64rem;
            height: 7.72rem;
            .tovh(max-height, 772);
            animation-delay: .5s;
            .svg {
                position: absolute;
                top: 0;
                right: 0;
                width: 7.57rem;
                // height: 7.28rem;
                .tovh(height, 728);
                // width: 757px;
                // height: 728px;
            }
        }

        .big-pic {
            width: 100%;
            height: 100%;
        }
    }
}

.container-four {
    // padding-top: 8vh;
    .tovh(padding-top, 166);
    .head {
        display: flex;
        justify-content: center;
    }

    .title {
        position: relative;
        font-size: 0.44rem;
        font-family: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #050029;
        line-height: 0.72rem;
        text-align: center;
    }

    .body {
        display: flex;
        justify-content: center;
        // margin-top: 0.8rem;

        // margin-top: 11vh;
        .body-left {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            padding-top: 1.44rem;
            max-width: 4.75rem;
            margin-left: 2rem;

            .product-title {
                // margin-top: 1.3rem;
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #1560fa;
                line-height: 36px;
                text-align: right;
            }

            .product-line {
                align-self: flex-end;
                margin: 0.16rem 0 0.24rem 0;
                width: 34px;
                height: 7px;
                background: #1560fa;
                border-radius: 99px;
            }

            .product-text {
                font-size: 0.2rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 30px;
            }
        }

        .body-right {
            position: relative;
            width: 5.79rem;
            height: 7.58rem;
            animation-delay: .5s;
            // width: 30vw;
            // height: 70vh;
            .svg {
                position: absolute;
                top: 0;
                left: 0;
                width: 7.2rem;
                height: 7.58rem;
                z-index: 3;
            }
        }

        .big-pic1 {
            position: absolute;
            top: 0;
            left: 0;
            width: 4.75rem;
            height: 7.58rem;
            z-index: 2;
        }

        .big-pic2 {
            position: absolute;
            bottom: 0.54rem;
            left: 0;
            width: 100%;
            height: 4.81rem;
            z-index: 1;
        }
    }
}

.container-five {
    // padding-top: 0.9rem;
    .tovh(padding-top, 156);
    .head {
        display: flex;
        justify-content: center;
    }

    .title {
        position: relative;
        font-size: 0.44rem;
        font-family: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #050029;
        line-height: 0.72rem;
        text-align: center;
    }

    .body {
        display: flex;
        justify-content: center;
        // margin-top: 0.8rem;

        .body-left {
            padding-top: 1.44rem;
            max-width: 4.75rem;

            .product-title {
                font-size: 0.28rem;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #1560fa;
                line-height: 36px;
            }

            .product-line {
                margin: 16px 0 24px 0;
                width: 34px;
                height: 7px;
                background: #1560fa;
                border-radius: 99px;
            }

            .product-text {
                font-size: 0.2rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 36px;
            }
        }

        .body-right {
            position: relative;
            width: 8.6rem;
            height: 7.65rem;
            animation-delay: .5s;
            // width: 44.7vw;
            // height: 70vh;
            .svg {
                position: absolute;
                top: 0;
                right: 0;
                width: 8.6rem;
                height: 7.65rem;
                // width: 757px;
                // height: 728px;
            }
        }

        .big-pic {
            width: 100%;
            height: 100%;
        }
    }
}

.container-six {
    //   padding-top: 0.9rem;
    // padding-top: 9vh;
    .tovh(padding-top, 90);
    background: url("../../assets/im/swiper3_bg.png");
    background-position: top left;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .head {
        display: flex;
        justify-content: center;
    }

    .container-six-text {
        .tovh(margin-top, 19);
        // margin-top: 19px;
        font-size: 0.28rem;
        font-family: PingFang SC-Regular, PingFang SC;
        color: #333333;
        text-align: center;
    }

    .title {
        display: flex;
        font-size: 0.44rem;
        font-family: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #050029;
        line-height: 0.72rem;
        text-align: center;
    }
}

.container-seven {
    // padding-top: 0.9rem;
    background: url("../../assets/im/video_bg.png");
    background-position: top left;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .video-box{
        position: relative;
        display: flex;
        flex-direction: column;
        .tovh(padding-top, 90);
        width: 100%;
        height: 100%;
        
        
    }
    .decorate-pic1 {
        position: absolute;
        right: 0;
        .tovh(top, 318);
        // top: 3.18rem;
        width: 101px;
        height: 120px;
    }

    .decorate-pic2 {
        position: absolute;
        left: 1.08rem;
        .tovh(top, 75);
        // top: 0.75rem;
        width: 93px;
        height: 85px;
    }

    .container-seven-text {
        margin-top: 19px;
        font-size: 0.28rem;
        font-family: PingFang SC-Regular, PingFang SC;
        color: #333333;
        text-align: center;
    }

    .container-seven-video {
        position: relative;
        flex: 1;

        .qipao {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 3;
            font-size: 0.24rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(22, 96, 250, 0.5);
            line-height: 0.42rem;
            [class^="qipao-item"]{
                &:hover {
                    animation-play-state: paused;
                }
            }
            .qipao-item {
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(255, 255, 255, 0.8);
                box-shadow: 0px 8px 16px 1px rgba(22, 96, 250, 0.06);
            }

            .qipao-item1 {
                position: absolute;
                top: 10px;
                left: -250px;
                width: 3.6rem;
                height: 0.82rem;
                border-radius: 41px 41px 0px 41px;
                animation: videop 25s infinite linear;
            }

            .qipao-item2 {
                bottom: 1.8rem;
                right: 1.5rem;
                width: 5.6rem;
                height: 0.82rem;
                border-radius: 41px 41px 0px 41px;
                animation: videop 22s infinite linear;
            }

            .qipao-item3 {
                top: 5.5rem;
                left: 150px;
                width: 3.54rem;
                height: 0.9rem;
                border-radius: 41px 41px 0px 41px;
                animation: videop 20s infinite linear;
            }

            .qipao-item4 {
                right: 256px;
                top: 4.5rem;
                width: 3.54rem;
                height: 0.9rem;
                border-radius: 41px 41px 0px 41px;
                animation: videop 19s infinite linear;
            }

            .qipao-item5 {
                right: 156px;
                top: 2.5rem;
                width: 3.54rem;
                height: 0.9rem;
                border-radius: 88px;
                border-radius: 41px 41px 0px 41px;
                animation: videop 23s infinite linear;
            }

            .qipao-item6 {
                left: -150px;
                top: 3.5rem;
                width: 3.54rem;
                height: 0.8rem;
                border-radius: 88px;
                border-radius: 41px 41px 0px 41px;
                animation: videop 25s infinite linear;
            }

            .qipao-item7 {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 15px;
                left: -100px;
                bottom: 3rem;
                width: 2.21rem;
                height: 0.5rem;
                font-size: 14px;
                border-radius: 88px;
                animation: videop 25s infinite linear;
                img{
                    width: 0.26rem;
                }
            }

            .qipao-item8 {
                display: flex;
                justify-content: space-between;
                padding: 0 15px;
                right: 3rem;
                bottom: 0.5rem;
                width: 2rem;
                height: 0.4rem;
                border-radius: 44px;
                font-size: 14px;
                animation: videop 20s infinite linear;
                img{
                    width: 0.26rem;
                }
            }
            .qipao-item9 {
                display: flex;
                justify-content: space-between;
                padding: 0 15px;
                right: 3rem;
                top: 0.8rem;
                width: 3.54rem;
                height: 0.8rem;
                border-radius: 88px;
                font-size: 0.26rem;
                animation: videop 20s infinite linear;
                img{
                    width: 0.56rem;
                }
            }
            .qipao-item11 {
                display: flex;
                justify-content: space-between;
                padding: 0 15px;
                left: 0.5rem;
                bottom: 0.8rem;
                width: 3.54rem;
                height: 0.8rem;
                border-radius: 88px;
                font-size: 0.26rem;
                animation: videop 20s infinite linear;
                img{
                    width: 0.56rem;
                }
            }
            .qipao-item10 {
                display: flex;
                justify-content: space-between;
                padding: 0 15px;
                left: 1.3rem;
                top: 1rem;
                width: 2rem;
                height: 0.4rem;
                border-radius: 44px;
                font-size: 14px;
                animation: videop 20s infinite linear;
                img{
                    width: 0.26rem;
                }
            }
        }

        .video-container {
            position: absolute;
            // .tovh(bottom, 342);
            top: 0.9rem;
            // top: 50%;
            left: 50%;
            transform: translate(-50%, 0);
            // .tovh(height, 442);
            // .tovw(height, 442);
            width: 7.86rem;
            height: 4.42rem;
            // height: 4.42rem;
            box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.1);
            border-radius: 0.32rem;
            z-index: 4;
            .im-video-decorate{
                position: absolute;
                bottom: 0;
                right: -5px;
                width: 1rem;
                height: 0.7rem;
                z-index: 7;
            }
            .video-bottom-bg{
                position: absolute;
                top: 0.25rem;
                left: 0.28rem;
                width: 7.6rem;
                // .tovh(height, 472);
                height: 4.72rem;
                z-index: 1;
            }
            .video-mask{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                // background: url("../../assets/im/video_mask.png");
                // background-position: top left;
                // background-size: 100% 100%;
                // background-repeat: no-repeat;
                z-index: 5;
                .video-mask-im{
                    font-size: 1.28rem;
                    font-family: PingFang SC-Heavy, PingFang SC;
                    font-weight: 800;
                    color: #FFFFFF;
                    line-height: 1.5rem;
                }
                .video-mask-text{
                    font-size: 0.32rem;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 0.38rem;
                }
            }
            .video-bf{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url("../../assets/im/video_mask.png");
                background-position: top left;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                z-index: 5;
                img{
                    width: 0.64rem;
                    height: 0.64rem;
                }
                .video-text{
                    display: flex;
                    align-items: center;
                    margin-top: 0.25rem;
                }
                .video-text1{
                    font-size: 0.32rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 0.38rem;
                }
                .video-text2{
                    font-size: 0.32rem;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 0.38rem;
                }
                .video-text-line{
                    margin: 0 21px;
                    width: 1px;
                    height: 0.32rem;
                    background-color: #DDDDDD;
                }
                .video-text-en{
                    font-size: 0.16rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: rgba(255, 255, 255, 0.6);
                    line-height: 19px;
                    letter-spacing: 1px;
                    transform: scale(0.8);
                }
            }
            video{
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: fill;
                border-radius: 0.32rem;
                z-index: 2;
            }
        }
    }

    @keyframes videop {
        0% {
            transform: translateX(0);
        }

        100% {
            transform: translateX(100vw);
        }
    }

    .container-seven-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding-top: 0.9rem;
        z-index: 2;
    }

    .head {
        display: flex;
        justify-content: center;

        .title {
            display: flex;
            font-size: 0.44rem;
            font-family: PingFang SC-Heavy, PingFang SC;
            font-weight: 800;
            color: #050029;
            line-height: 0.72rem;
            text-align: center;
        }
    }
}

.container-eight {
    display: flex;
    flex-direction: column;

    .container-eight-body {
        flex: 1;
        // padding-top: 0.9rem;
        .tovh(padding-top, 90);
        .head {
            display: flex;
            justify-content: center;

            .title {
                display: flex;
                font-size: 0.44rem;
                font-family: PingFang SC-Heavy, PingFang SC;
                font-weight: 800;
                color: #050029;
                line-height: 0.72rem;
                text-align: center;
            }
        }

        .container-eight-text {
            margin-top: 19px;
            font-size: 0.28rem;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #333333;
            text-align: center;
            animation-delay: .2s;
        }

        .download-pic-box {
            display: flex;
            justify-content: center;
            .tovh(margin-top, 200);
            // margin-top: 2rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-size: 0.2rem;
            animation-delay: .4s;
                .text {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                }
                .down-pic {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 0.38rem;
                        height: 0.38rem;
                    }
                }
                .down-pic-ios{
                    font-size: 0.2rem;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    // img {
                    //     margin-left: 0.12rem;
                    //     width: 0.23rem;
                    //     height: 0.23rem;
                    // }
                }
                .download-mac-pic{
                    margin-right: 16px;
                    width: 0.37rem;
                    height: 0.43rem;
                }
                .download-windows-pic{
                    margin-right: 15px;
                    width: 0.32rem;
                    height: 0.3rem;
                }
                .ios-pic {
                    margin: 0 32px 0 0;
                    width: 3.18rem;
                    height: 0.78rem;
                    background: linear-gradient(268deg, #C4C4C4 0%, #CCFFEA 0%, #80FFD1 100%);
                    box-shadow: 0 4px 10px 0 rgba(69, 255, 189, .32);
                    border-radius: 39px;
                    color: #333333;
                    cursor: pointer;
                    overflow: hidden;
                }

                .windows-pic {
                    margin: 0 0 0 32px;
                    width: 3.18rem;
                    height: 0.78rem;
                    background: linear-gradient(268deg, #146AFE 0%, #0220F7 100%);
                    box-shadow: 0 4px 10px 0 rgba(0, 86, 249, .32);
                    border-radius: 39px;
                    color: #ffffff;
                    cursor: pointer;
                    overflow: hidden;
                }

                .download-btn-down {
                    .down-pic {
                        -webkit-animation-play-state: paused;
                        animation-play-state: paused;
                        -webkit-animation: activeDown .2s forwards;
                        animation: activeDown .2s forwards;
                    }

                    .text1 {
                        -webkit-animation-play-state: paused;
                        animation-play-state: paused;
                        -webkit-animation: normalDown .5s forwards;
                        animation: normalDown .5s forwards;
                    }
                }

                .download-btn-up {
                    .down-pic {
                        -webkit-animation-play-state: paused;
                        animation-play-state: paused;
                        -webkit-animation: activeUp .5s forwards;
                        animation: activeUp .5s forwards;
                    }

                    .text1 {
                        -webkit-animation-play-state: paused;
                        animation-play-state: paused;
                        -webkit-animation: normalUp .2s forwards;
                        animation: normalUp .2s forwards;
                    }
                }
        }
    }

    .container-eight-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        height: 2.14rem;
        background-color: #1E1E1E;
        animation-delay: .6s;
        user-select: text;
        .footer-left {
            .footer-link-list {
                display: flex;
            }

            .footer-link-item {
                font-size: 14px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #999999;
                line-height: 16px;
                cursor: pointer;
            }

            .company-item-mx {
                margin: 0 20px;
            }

            .footer-link-line {
                margin: 0 10px;
                width: 1px;
                height: auto;
                background-color: #999999;
            }

            .footer-company {
                margin-top: 0.2rem;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 14px;

                .footer-company-item {
                    margin-top: 8px;
                }
            }
        }

        .footer-right {
            display: flex;

            .code-box {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .code-box:nth-of-type(2) {
                margin-left: 40px;
            }

            .code-text {
                margin-top: 14px;
                font-size: 14px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 16px;
            }

            img {
                width: 0.84rem;
                height: 0.84rem;
            }
        }
    }
}
</style>